import type { InventoryPurchaseLine } from '../types/inventory';
import { formatMoney, formatQuantity } from './costFormatting';

// 26A-4: resumen de líneas para la lista de compras. Puro y probado. La lista muestra hasta
// MAX_PREVIEW_LINES insumos por compra; el resto se resume como "+N más" (el detalle sigue teniendo todo).
// Tolera `lines` ausente (backend anterior a 26A-4 durante la ventana de deploy): muestra nada, no falla.
export const MAX_PREVIEW_LINES = 5;

export type PurchaseLinePreview = Pick<InventoryPurchaseLine, 'id' | 'quantity' | 'unitCost'> & { ingredient: { name: string }; unit: { symbol: string } };

export function purchaseLinesPreview<T extends PurchaseLinePreview>(lines: T[] | undefined, max = MAX_PREVIEW_LINES): { visible: T[]; hiddenCount: number } {
  const all = lines ?? [];
  if (all.length <= max) return { visible: all, hiddenCount: 0 };
  return { visible: all.slice(0, max), hiddenCount: all.length - max };
}

// "2 L × $32.00": cantidad con unidad y costo unitario, lo que hace falta para detectar un error de
// captura (264 L por $0.24 salta a la vista) sin abrir el detalle.
export function describePurchaseLineAmounts(line: PurchaseLinePreview): string {
  return `${formatQuantity(line.quantity)} ${line.unit.symbol} × ${formatMoney(line.unitCost)}`;
}
